module.exports = __webpack_public_path__ + "img/c8.c7c845ea.png";